import ApiService from '@/services/api.service'

const ReasonService = {
    getAll() {    
      return ApiService.get('/Reasons?Active=true&ReasonType=CHECKIN');      
    },
  
    get( id) {
      return ApiService.get(`/races/${id}`);
    },

    getReasonMars() {    
      return ApiService.get('/Reasons?Active=true&ReasonType=MARS');      
    },

    getReasonTars() {    
      return ApiService.get('/Reasons?Active=true&ReasonType=TARS');      
    },

    getReasonInventory() {    
      return ApiService.get('/Reasons?Active=true&ReasonType=INVENTORY');      
    },
  
    
  }
  
  export default ReasonService;